import { Component, Input, OnInit } from '@angular/core';
import { UtilityService } from '@core/services/utility.service';

@Component({
	selector: 'records-not-found',
	templateUrl: './records-not-found.component.html',
	styleUrls: ['./records-not-found.component.scss'],
	standalone: false,
})
export class RecordsNotFoundComponent implements OnInit {
	constructor(public util: UtilityService) {}

	@Input() removeFilterText = false;
	ngOnInit(): void {}
}
